module.exports = __webpack_public_path__ + "img/drag_indicator.976a5133.svg";